'use client';

import React, { useEffect, useRef } from 'react';

import { LocationPickerContent } from '@website/components/LocationPicker/LocationPickerContent';

import { LocationPickerHeader } from './LocationPickerHeader';

interface LocationPickerDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  onLocationSelect: (location: { latitude: number; longitude: number; name: string }) => void;
}

/**
 * LocationPickerDrawer - Full-screen overlay for location picker on mobile.
 */
export const LocationPickerDrawer: React.FC<LocationPickerDrawerProps> = ({ isOpen, onClose, onLocationSelect }) => {
  const scrollYRef = useRef(0);

  useEffect(() => {
    if (!isOpen) return;

    scrollYRef.current = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollYRef.current}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      window.scrollTo(0, scrollYRef.current);
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[120] bg-white flex flex-col animate-in slide-in-from-bottom duration-200">
      <div className="flex-shrink-0">
        <LocationPickerHeader onBackClick={onClose} />
      </div>
      <div className="flex-1 min-h-0 px-5 pb-5">
        <LocationPickerContent onLocationSelect={onLocationSelect} />
      </div>
    </div>
  );
};

export default LocationPickerDrawer;
